/**
 * 剪贴板工具函数
 * 支持多种复制方案，确保在各种环境下都能正常工作
 */

/**
 * 复制文本到剪贴板
 * 支持降级方案：
 * 1. 现代 Clipboard API（推荐，安全上下文）
 * 2. 传统 execCommand('copy')（兼容性保障）
 * 3. 手动复制提示
 */
export async function copyToClipboard(text: string): Promise<boolean> {
  // 方法1: 尝试使用现代 Clipboard API
  if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
    try {
      await navigator.clipboard.writeText(text)
      return true
    } catch (err) {
      console.warn('Clipboard API 失败，尝试降级方案:', err)
    }
  }
  
  // 方法2: 降级方案 - 使用传统的 execCommand
  try {
    const textArea = document.createElement('textarea')
    textArea.value = text
    textArea.style.position = 'fixed'
    textArea.style.left = '-999999px'
    textArea.style.top = '-999999px'
    textArea.style.opacity = '0'
    textArea.setAttribute('readonly', '')
    
    document.body.appendChild(textArea)
    
    if (navigator.userAgent.match(/ipad|iphone/i)) {
      const range = document.createRange()
      range.selectNodeContents(textArea)
      const selection = window.getSelection()
      if (selection) {
        selection.removeAllRanges()
        selection.addRange(range)
      }
      textArea.setSelectionRange(0, 999999)
    } else {
      textArea.select()
      textArea.setSelectionRange(0, 999999)
    }
    
    const successful = document.execCommand('copy')
    document.body.removeChild(textArea)
    
    if (successful) {
      return true
    }
  } catch (err) {
    console.error('降级复制方案失败:', err)
  }
  
  // 方法3: 提示用户手动复制
  if (typeof prompt === 'function') {
    prompt('请手动复制以下内容：', text)
  } else {
    alert(`请手动复制：\n\n${text}`)
  }
  
  return false
}

export function isClipboardSupported(): boolean {
  return !!(navigator.clipboard && typeof navigator.clipboard.writeText === 'function')
}

export function isSecureContext(): boolean {
  return window.isSecureContext === true
}

export function getClipboardInfo(): {
  hasClipboardAPI: boolean
  isSecure: boolean
  userAgent: string
} {
  return {
    hasClipboardAPI: isClipboardSupported(),
    isSecure: isSecureContext(),
    userAgent: navigator.userAgent
  }
}
